<div id="layout-wrapper">

  <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()">
  </app-topbar>

  <app-sidebar></app-sidebar>

  <div class="main-content">
    <div class="page-content">
      <!-- content -->
      <router-outlet></router-outlet>
      <div>
        <a href="javascript:void(0);" class="message-send" (click)="gotoMessage()"><i class="mdi mdi-message"></i></a>
      </div>
    </div>

    <!-- footer -->
    <!-- <app-footer></app-footer> -->
  </div>
</div>
